module.exports = __webpack_public_path__ + "static/media/rmt-side.7120a907.jpg";